import type { LegendItem as MapLegendItem, MapGroup } from '../../../types/mapTypes'
import mapBaseLayers from './map-base-layers.config.json'

export interface Theme {
  id: string
  title: string
}

export interface ExtendedMapGroup extends MapGroup {
  isVisible: boolean
  isEmbedded: boolean
}
export interface ExtendedMapGroupLegendItem extends MapLegendItem {
  isVisible: boolean
  isEmbedded: boolean
}

export interface MapBaseLayer {
  category: string
  label: string
  urlTemplate: string
  imageUrl?: string
  infraRed?: boolean
  id: string
}

export function getMapBaseLayer(requestedId: string): MapBaseLayer | undefined {
  const layer = mapBaseLayers.find(({ value }) => value === requestedId)

  if (!layer) {
    return undefined
  }

  return { id: layer.value, ...layer }
}

export function getMapBaseLayers(requestedCategory: string): MapBaseLayer[] {
  return mapBaseLayers
    .filter(({ category }) => category === requestedCategory)
    .map(({ value, ...layer }) => ({ id: value, ...layer }))
}
